import {AnimatePresence, motion} from 'framer-motion'
import {PropsWithChildren} from 'react'
import {useWindowSize} from 'react-use'
import {BREAKPOINTS} from 'src/common/constants'

type SubmenuProps = PropsWithChildren & {
  handleMouseEnter: () => void
  handleMouseLeave: () => void
  isOpen: boolean
}

export const DesktopSubmenu = ({children, handleMouseEnter, handleMouseLeave, isOpen}: SubmenuProps) => {
  const isMobile = useWindowSize().width < BREAKPOINTS.DESKTOP

  if (isMobile) {
    return null
  }

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="absolute left-0 top-[60px] flex w-full justify-center pt-2 font-normal lg:px-5 xl:px-0"
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          exit={{opacity: 0}}
          transition={{duration: 0.3}}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          id="desktop-submenu-container"
        >
          <div className="relative flex w-full max-w-[1200px] gap-y-0 rounded-[4px] border-grey-135 bg-moss-white/[90%] font-normal backdrop-blur-[150px]">
            {children}
            <div className="pointer-events-none absolute inset-0 rounded-[4px] border bg-transparent lg:border-moss-black/[10%]" />
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  )
}
